import { ComponentPropsWithoutRef, CSSProperties } from "react";
import styles from "./styles.module.scss";
import { TextTag } from "@/shared/ui/Typography/types";
import { twCn } from "@/styles/utils";

type Props<T extends TextTag> = ComponentPropsWithoutRef<T> & {
  as?: T;
  type?:
    | "default"
    | "bodyBold"
    | "subText"
    | "title"
    | "menu"
    | "caption"
    | "h1"
    | "h2";
  weight?: "medium" | "semiBold" | "bold";
  color?: CSSProperties["color"];
  align?: CSSProperties["textAlign"];
  lineHeight?: CSSProperties["lineHeight"];
};

export const Typography = <T extends TextTag = "span">({
  as,
  type = "default",
  weight,
  align = "left",
  lineHeight,
  color,
  className = "",
  ...props
}: Props<T>) => {
  const Tag = as ?? "span";

  return (
    <Tag
      {...props}
      style={{ color, lineHeight, textAlign: align }}
      className={
        twCn(
          "text-inherit",
          className,
          styles[type],
          weight && styles[weight],
        ) || undefined
      }
    />
  );
};
